var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"90%","margin-top":"3.5rem"},attrs:{"id":"echart-line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }